import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, Input, ChangeDetectorRef, Inject} from '@angular/core';
import { BuildingScoresService } from '../services/building-scores.service';
import { AdjustScoreWeightsService } from '../services/adjust-score-weights.service';
import { Router } from '@angular/router';
import { MouseEvent, AgmMap, LatLngBounds } from '@agm/core';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { IMyDpOptions } from 'mydatepicker';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { ScoreWeight } from '../core/models/score-weight';
import { PortalType } from '../core/portal-types';
import { FilterPreset } from '../core/models/filter-preset';
import { FilterService } from '../services/filter.service';
import { BuildingRatingsFilter } from '../core/models/building-ratings-filter';
import { ListRatingFiltersComponent } from '../shared/list-rating-filters/list-rating-filters.component';
import { MarketBuildingService } from '../services/market-building.service';
import { Paths } from '../constants';

declare var google: any;
declare var $: any;

const defaultMaxValue = 'No Max';
const defaultMinValue = 'No Min';

@Component({
	selector: 'app-building-scores',
	templateUrl: './building-scores.component.html',
	styleUrls: ['./building-scores.component.css']
})
export class BuildingScoresComponent implements OnInit, AfterViewInit {
	public DEBUG_LIMIT_RESULTS:any = 99999;

	IconUrl = environment.BaseURI_Icon_MarketBuilding;

	@ViewChild('fromDate') inputFromDate: ElementRef;
	@ViewChild('toDate') inputToDate: ElementRef;

	@ViewChild(ListRatingFiltersComponent) listRatingFiltersComponent!: ListRatingFiltersComponent;

	private selectedScoreWeightSubscription: Subscription;

	public portalType: PortalType = PortalType.Rating;
	public paths: any = Paths;
	public ratingMethodology: string = '';

	public buildingFilter: BuildingRatingsFilter = {
		//Base Options
		buildingClasses: [],
		cities: [],
		dateEnd: null,
		dateStart: null,
		leaseTypes: [],
		ratingToRentRatioCurrent: {
			minimum: null,
			maximum: null
		},
		searchTerm: null,
		submarkets: [],
		districts: [],
		postalCodes: [],
		scoreWeightId: "",

		//Building Options
		buildingTenancies: [{ label: "Office Leased", value: "Office Leased" }],
		buildingStatuses: [],
		competitiveSets: [],
		askingRent: {
			minimum: null,
			maximum: null
		},
		percentLeased: [0, 100],
		directAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		subleaseAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		totalVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		directVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		subleaseVacantSquareFootage: {
			minimum: null,
			maximum: null
		},
		maxContiguousSquareFootage: {
			minimum: null,
			maximum: null
		},
		// Removed on 7/10/24
		// Removed on 7/10/24
		minimumAvailableSquareFootage: {
			minimum: null,
			maximum: null
		},
		// Removed on 7/10/24
		// Removed on 7/10/24
		occupiedSquareFootage: {
			minimum: null,
			maximum: null
		},
		availableSquareFootage: [0, 400000],
		subclasses: [],
		propertyTypes: [],
		buildingRenovations: [],
		yearOfRenovation: {
			minimum: null,
			maximum: null
		},
		mixedUses: [],
		singleTenants: [],
		parking: [],
		numberOfFloors: {
			minimum: null,
			maximum: null
		},
		propertySize: {
			minimum: null,
			maximum: null
		},
		parkingRatio: {
			minimum: null,
			maximum: null
		},
		walkScore: [0, 100],
		proximityToLightRail: {
			minimum: null,
			maximum: null
		},

		//Rating Options
		total: {
			rating: [0, 105],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		constructionQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		askingRate: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		commonAreaQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		onSiteAmenities: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		sizeStories: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		ageBonus: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProminence: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		relevanceToConsumer: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationConvenience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		locationProximity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingVisitorExperience: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuantity: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
		parkingQuality: {
			rating: [0, 10],
			numeric: [defaultMinValue, defaultMaxValue],
			percentage: [defaultMinValue, defaultMaxValue]
		},
	};
	
	public submarketOptions: string[];
	public districtOptions: string[];
	public buildingClassOptions: string[];
	public leaseTypeOptions: string[];

	public buildingTenantOptions: string[];
	public buildingStatusOptions: string[];
	public competitiveSetOptions: string[];
	public subclassOptions: string[];
	public propertyTypeOptions: string[];
	public buildingRenovationOptions: string[];
	public mixedUseOptions: string[];
	public singleTenantOptions: string[];
	public parkingOptions: string[];

	public userFilterPresets: FilterPreset[] = [];
	public userFilterPreset: FilterPreset = {
		id: "",
		name: "",
		userId: null,
		filter: null,
		createdUtc: null,
		updatedUtc: null
	}

	inputRatingToRentRatioMinValue: string;
	inputRatingToRentRatioMaxValue: string;
	// @ViewChild('containerMap') containerMap: ElementRef;
	showHeaderOptions: boolean = true;
	@Input() IsRefreshMap: boolean = false;
	Buildingobj: any = {};
	totalbuilding: number;
	totalPercentage: number;
	isPageFirstTime: boolean = true;
	rightSectionColor = { 'background': '#ffffff' };
	public fromDate: Date;
	public endDate: Date;

	public sortParam: string = 'totalScore';
	public sortOrder: string = 'descending';
	public sortBtn: any;

	defultDateSelected: boolean = false;
	public quarterAndQuarterYearList: SelectItem[];
	getdatedefault: any = [];
	//public quarterAndQuarterYearList: any = [];
	public buildingScoresListByPropertyId: any = [];
	public buildingScoresList: any = [];
	public buildingScoresListCopy: any = [];
	public buildingScoresListAll: any = [];

	public MapLoader = false;
	buildinglist: any[];
	deletedIdOfficeBuilding: Array<Custom> = [];
	totalSQFt: number = 0;
	totalVancentSQFt: number = 0;
	contiguousSFMin: number;
	percentvacant: number = 0;
	//loader: boolean = true;
	isMarkerSingle: boolean = false;
	selectedFromQuarter: Absorption[];
	selectedToQuarter: Absorption[];
	selectedFromQuarterstr1: string;
	selectedFromQuarterstr2: string;
	a: SelectItem[];
	// selectedFromQuarter: string='Q12019';
	// selectedToQuarter: string='Q32019';
	markers: marker[];
	@ViewChild('AgmMap') agmMap: AgmMap;
	val: number[] = [0, 672401];
	val2: number = 672401;
	//declare variable for filter
	minValueSF: number;
	maxValueSF: number;
	rangeSFMaxValue: number;

	fromDateRange: string;
	toDateRange: string;
	absorptionForOccupiedSF: string = '';
	propertyId: string = '';
	PreviousAbsoptionData: string;
	CurrentabsorptionData: number;
	value: Date;
	placeholder: string = '';
	zoom: number = 10;
	latitude: number = 33.438031;
	longitude: number = -111.955689;
	myFromDate: string;
	myToDate: string;
	myDecimal: number;
	isCompetitiveSetFilterSelected: number = 0;
	deletedPropertyIdFromOfficeBuildingList: string;
	obj = []
	defaultDate = new Date();
	setDateOnSelectPicker: boolean = false;
	FromQDate: string;
	ToQdate: string;
	f: any = [];
	t: any = [];
	QStartDate: Date;
	Qday: string;
	QMonth: string;
	QYear: string;
	QDate: string;
	FromDateString: string;
	ToDateString: string;
	myDatePickerOptions: IMyDpOptions = {
		//todayBtnTxt: 'Today',
		dateFormat: 'mm/dd/yyyy',
		ariaLabelInputField: '',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		inline: false,
		//disableUntil: { year: 2016, month: 8, day: 10 }

	};

	buildingLinkOpenInNewTab(url: string): void {
		const fullUrl = window.location.origin + url;
    	window.open(fullUrl, '_blank');
	}
	
	calculateRatingToRent(totalScore: number, minDirLsRate_Yr: number) {
		if (totalScore === 0 || minDirLsRate_Yr === 0) {
			return "N/A";
		}
		return (totalScore / minDirLsRate_Yr).toPrecision(3);
	}


	public isSnazzyInfoWindowOpened: Object = {};

	public toggleSnazzyInfoWindow(propId) {
		console.log(`Toggling Snazzy Info Window`);
		console.log(`before: ${propId} ${this.isSnazzyInfoWindowOpened[propId]}`);
		if(!propId) {
			this.isSnazzyInfoWindowOpened = {};
			this.route.navigate([],{
				queryParams: {
					'propertyId':null,
				},
				queryParamsHandling:'merge'
			})
			return;
		}
		if(!this.isSnazzyInfoWindowOpened[propId]) {
			this.isSnazzyInfoWindowOpened[propId] = true;
			this.route.navigate([],{
				queryParams: {
					'propertyId':propId,
				},
				queryParamsHandling:'merge'
			})
		}
		else {
			this.isSnazzyInfoWindowOpened[propId] = false;
		}
		console.log(`after: ${propId} ${this.isSnazzyInfoWindowOpened[propId]}`);
	}

	public snazzyInfoWindowIsToggled($isOpen: boolean, propId:any) {
		console.log(`snazzyInfoWindowIsToggled ${$isOpen} ${propId}`);
		// Keep isSnazzyInfoWindowOpened up-to-date (e.g. if window was closed on map click)
		this.isSnazzyInfoWindowOpened[propId] = $isOpen;
		// Force detect changes.
		// Not necessarily needed. Depends on your projet
		// Here needed if window was closed on map click
		setTimeout(()=>{
			console.log(Object.values(this.isSnazzyInfoWindowOpened).filter(e=>e==true));
			if(Object.values(this.isSnazzyInfoWindowOpened).filter(e=>e==true).length == 0) {
				this.clearURLParams('thingie');
			}
		},50)
		this.changeDetectorRef.detectChanges();
	}

	public scoreWeight:ScoreWeight = {
		id: "",
		name: "",
		default: false,
		userId: 0,
		constructionQuality: 0,
		askingRate: 0,
		commonAreaQuality: 0,
		onsiteAmenities: 0,
		sizeStories: 0,
		ageBonus: 0,
		locationProminence: 0,
		relevanceToConsumer: 0,
		locationConvenience: 0,
		locationProximity: 0,
		parkingVisitorExperience: 0,
		parkingQuantity: 0,
		parkingQuality: 0,
		updatedUtc: new Date(),
	};

	public myFormFromDate: FormGroup;
	public myFormTodate: FormGroup;
	public model: any = { date: { year: 2018, month: 10, day: 9 } };
	public model2: any = { date: { year: 2018, month: 10, day: 9 } };

	public FilterType: string = '';
	public TotalScoreFilterNumberRangeError: boolean = false;
	public TotalScoreFilterPercentRangeError: boolean = false;

	public ConstructionQualityFilterNumberRangeError: boolean = false;
	public ConstructionQualityFilterPercentRangeError: boolean = false;

	public AskingRateFilterNumberRangeError: boolean = false;
	public AskingRateFilterPercentRangeError: boolean = false;

	public CommonAreaQualityFilterNumberRangeError: boolean = false;
	public CommonAreaQualityFilterPercentRangeError: boolean = false;

	public OnsiteAmenitiesFilterNumberRangeError: boolean = false;
	public OnsiteAmenitiesFilterPercentRangeError: boolean = false;

	public SizeStoriesFilterNumberRangeError: boolean = false;
	public SizeStoriesFilterPercentRangeError: boolean = false;

	public AgeBonusFilterNumberRangeError: boolean = false;
	public AgeBonusFilterPercentRangeError: boolean = false;

	public LocationProminenceFilterNumberRangeError: boolean = false;
	public LocationProminenceFilterPercentRangeError: boolean = false;

	public RelevanceToConsumerFilterNumberRangeError: boolean = false;
	public RelevanceToConsumerFilterPercentRangeError: boolean = false;

	public LocationConvenienceFilterNumberRangeError: boolean = false;
	public LocationConvenienceFilterPercentRangeError: boolean = false;

	public LocationProximityFilterNumberRangeError: boolean = false;
	public LocationProximityFilterPercentRangeError: boolean = false;

	public ParkingVisitorExperienceFilterNumberRangeError: boolean = false;
	public ParkingVisitorExperienceFilterPercentRangeError: boolean = false;

	public ParkingQuantityFilterNumberRangeError: boolean = false;
	public ParkingQuantityFilterPercentRangeError: boolean = false;

	public ParkingQualityFilterNumberRangeError: boolean = false;
	public ParkingQualityFilterPercentRangeError: boolean = false;

	public ordinalize(num) {
		return num != null ? moment.localeData().ordinal(num) : '-';
	}

	public onZoomChange(newZoom) {
		console.log(`current zoom: ${this.zoom}, newZoom: ${newZoom}`);
		this.zoom = newZoom;
	}

	public centerAndZoomOnMarker(item) {
		// console.log("currentCenter:",this.currentCenter,"currentZoom:",this.zoom);
		// console.log(item);
		this.currentCenter = {lat:parseFloat(item.latitude),lng:parseFloat(item.longitude)};
		// const interValZoom1 = setInterval(() => {
		// 	this.zoom = this.zoom - 2 ;
		// 	if (this.zoom <= 14) {
		// 		this.zoom = 14;
		// 		clearInterval(interValZoom1);
		// 		// stop the zoom at your desired number
		// 	}
		// }, 300);
		// setTimeout(() => {
		// 	const interValZoom2 = setInterval(() => {
		// 		this.zoom = this.zoom + 2 ;
		// 		if (this.zoom >= 17) {
		// 			this.zoom = 17;
		// 			clearInterval(interValZoom2);
		// 			// stop the zoom at your desired number
		// 		}
		// 	}, 300);
		// },1000);
	}

	myMap:any;

	// customStyles: Array<any> = [ {"elementType": "geometry", "stylers": [{"color": "#ebe3cd"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#523735"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"} ] }, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#c9b2a6"} ] }, {"featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{"color": "#dcd2be"} ] }, {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#ae9e90"} ] }, {"featureType": "landscape.natural", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#93817c"} ] }, {"featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{"color": "#a5b076"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#447530"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#f5f1e6"} ] }, {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#fdfcf8"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#f8c967"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#e9bc62"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{"color": "#e98d58"} ] }, {"featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{"color": "#db8555"} ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#806b63"} ] }, {"featureType": "transit", "stylers": [{"visibility": "off"} ] }, {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{"color": "#8f7d77"} ] }, {"featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{"color": "#ebe3cd"} ] }, {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#dfd2ae"} ] }, {"featureType": "water", "elementType": "geometry.fill", "stylers": [{"color": "#b9d3c2"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#92998d"} ] } ];
	customStyles: Array<any> = [{"elementType": "geometry", "stylers": [{"color": "#242f3e"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#746855"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#242f3e"} ] }, {"featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "poi.attraction", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.business", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#274e36"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#6b9a76"} ] }, {"featureType": "poi.place_of_worship", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi.school", "stylers": [{"visibility": "off"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#38414e"} ] }, {"featureType": "road", "elementType": "geometry.stroke", "stylers": [{"color": "#212a37"} ] }, {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"color": "#9ca5b3"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#746855"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#1f2835"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#f3d19c"} ] }, {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#2f3948"} ] }, {"featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{"color": "#d59563"} ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#3a65a6"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#515c6d"} ] }, {"featureType": "water", "elementType": "labels.text.stroke", "stylers": [{"color": "#17263c"} ] } ];

	ngAfterViewInit() {
		// console.log(this.agmMap);
		// this.agmMap.mapReady.subscribe(map => {
		// const bounds: LatLngBounds = new google.maps.LatLngBounds();
		// for (const mm of this.markers) {
		//   bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
		// }
		// map.fitBounds(bounds);
		// });

		// let query = this.route.parseUrl(this.route.url).queryParams;
		// // if(query.propertyId) {
		// setTimeout(()=>this.clickedMarker(query.propertyId,0),3000);
		// }
		// this.clickedMarker(query.propertyId,0);
	}

	defaultCenter = { lat: 33.526567, lng: -112.064364 };
	currentCenter = {...this.defaultCenter};


	constructor(
		@Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef, 
		private marketService: MarketBuildingService, 
		private scoreWeightsService: AdjustScoreWeightsService, 
		private filterService: FilterService, 
		public scoresService: BuildingScoresService, 
		private route: Router, 
		private formBuilder: FormBuilder, 
		private datePipe: DatePipe, 
		private location: Location) 
	{
		this.BuildingSquareFootageMinMaxValue();
		this.onBuildingFilterChange(event,true);

		if (this.IsRefreshMap) {
			this.onBuildingFilterChange(event,true);
		}
	}

	clickedRightSideItem(propId) {
		this.clickedMarker(propId, null);
		// if(!propId) return;
		// this.location.replaceState(`/buildingScores?propertyId=${propId}`);
		// this.toggleSnazzyInfoWindow(propId);
	}

	async ngOnInit() {
		// this.selectedFromQuarterstr1= 'Q42019';
		sessionStorage.removeItem('PrevisousAbsorption');
		//localStorage.removeItem('PrevisousAbsorption');


		// this.CurrentUser = sessionStorage.getItem('email');
		// this.CurrentUserName = sessionStorage.getItem('fullName');
		// this.CurrentUserRole = sessionStorage.getItem('role');
		// if (this.CurrentUserRole === 'admin') {
		//   this.IsAdmin = true;
		// }

		this.myDecimal = 0.01;
		this.MapLoader = true;
		this.fromDate = new Date(1900, 1, 1);
		//  this.fromDate = new Date("12/15/18 00:00:00")
		//this.fromDate = new Date(year: 2018, month: 10, day: 9 )
		this.endDate = new Date();

		//console.log(new Date());
		//console.log(this.endDate);
		this.myFormFromDate = this.formBuilder.group({
			myFromDate: [{ date: { year: this.fromDate.getFullYear(), month: this.fromDate.getMonth(), day: this.fromDate.getDate() } }, Validators.required]

		});

		//console.log(this.myFormFromDate + "calling " + this.myFromDate + "FromDate Year: " + this.fromDate.getFullYear() + " Month: " + this.fromDate.getMonth() + " Date: " + this.fromDate.getDate());
		this.myFormTodate = this.formBuilder.group({
			myToDate: [{ date: { year: this.endDate.getFullYear(), month: this.endDate.getMonth() + 1, day: this.endDate.getDate() } }, Validators.required]
		});

		let dateFrom = new Date("01/01/1900");
		this.FromDateString = this.datePipe.transform(dateFrom, 'MM/dd/yyyy');
		this.ToDateString = this.datePipe.transform(this.endDate, 'MM/dd/yyyy');


		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;

		this.buildingScoresListCopy = null;

		this.agmMap.mapReady.subscribe(async map => {
			// console.log('subscribe event called');
			this.myMap = map;
			let place = await this.geocode("Phoenix, USA")
			this.currentCenter = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
			console.log('geocoded center:',this.currentCenter);
			// this.currentCenter = { lat: 33.526567, lng: -112.064364 };
			// console.log('center:',this.currentCenter);
		});

		this.BuildingTenancy();
		this.SubMarket();
		this.District();
		this.BuildingClass();
		this.BuildingLeaseType();
		this.BuildingSubclass();
		this.BuildingPropertyType();
		this.BuildingRenovations();
		this.BuildingMixedUse();
		this.BuildingSingleTenant();
		this.BuildingParking();
		this.BuildingStatus();
		this.scoresService.mapTypeIdSelected = this.agmMap.mapTypeId;

		this.selectedScoreWeightSubscription = this.scoresService.selectedWeight$.subscribe(value => {
			this.scoreWeight = value;
			this.buildingFilter.scoreWeightId = value.id;
		});

		this.CompetitiveSet();
		this.getUserFilters();

		$('[data-toggle="tooltip"]').tooltip();
		this.buildinglist = [
			{ field: 'id', header: 'Id', },
			{ field: 'buildingName', header: 'Building Name' },
			{ field: 'address', header: 'Address' },
			{ field: 'buildingNRA', header: 'BuildingNRA' },
			{ field: 'ttlVacantSF', header: 'TTLVacantSF' },
		];

		$(document).on('keyup', e=>e.key == 'Escape' && $('.si-close-button').click());
		$('.dataPickerInput').datepicker([]);
		$('.filterHead').click(function () {
			$(this).toggleClass("bodyShow");
			$(".filterBodySecond").slideToggle(300);
		});

		// let query = this.route.parseUrl(this.route.url).queryParams;
		// if(query.propertyId) {
		// 	setTimeout(()=>this.clickedMarker(query.propertyId,0),3000);
		// }

		this.scoresService.GetAssetBuildingRatingMethodology().subscribe(
			(res: any) => {
				if (res != null && res != '') {
					this.ratingMethodology = res;
				}				
			},
			err => {
        		console.log(err);
			}
		);
	}

	getUserFilters() {
		this.filterService.GetUserFilters(this.portalType).subscribe(
			(res: FilterPreset[]) => {
				this.userFilterPresets = res;
			},
			err => {
				console.log("Could not retrieve user filters: ", err);
			}
		);
	}

	userFilterChange(preset: FilterPreset) {
		try {
			this.buildingFilter = preset.filter;
		} catch (error) {
			console.log("Invalid filter.", error);
			alert("Invalid filter.");
		}
	}

	showFilterModal = false;

	openUserFilterModal() {
		this.showFilterModal = true;
	}

	closeUserFilterModal() {
		this.showFilterModal = false;
	}

	onDeleteUserFilter(filterId: string) {
		this.getUserFilters();
	}

	showFilterAddModal = false;

	openUserFilterAddModal() {
		this.showFilterAddModal = true;
	}

	closeUserFilterAddModal() {
		this.showFilterAddModal = false;
	}

	onAddUserFilter() {
		this.showFilterAddModal = false;
		this.getUserFilters();
	}

	ClearAll(eventData) {

		this.getUserFilters();

		this.listRatingFiltersComponent.clearRatingFilters();

		if (eventData == 'true') {
			this.ClearBuildingFilters();
		}
	}

	ClearBuildingFilters() {
		this.fromDate = new Date(1900, 1, 1);
		this.endDate = new Date();
		this.myFormFromDate = this.formBuilder.group({
			myFromDate: [{ date: { year: this.fromDate.getFullYear(), month: this.fromDate.getMonth(), day: this.fromDate.getDate() } }, Validators.required]

		});
		this.myFormTodate = this.formBuilder.group({
			myToDate: [{ date: { year: this.endDate.getFullYear(), month: this.endDate.getMonth() + 1, day: this.endDate.getDate() } }, Validators.required]
		});
		let dateFrom = new Date("01/01/1900");
		this.FromDateString = this.datePipe.transform(dateFrom, 'MM/dd/yyyy');//"YEAR#" + this.fromDate.getUTCFullYear() + "@@MONTH#" + this.fromDate.getUTCDay() + "@@DAY#" + this.fromDate.getUTCDate();
		//this.ToDateString = this.endDate.toDateString();
		this.ToDateString = this.datePipe.transform(this.endDate, 'MM/dd/yyyy');//"YEAR#" + this.endDate.getUTCFullYear() + "@@MONTH#" + this.endDate.getUTCDay() + 1 + "@@DAY#" + this.endDate.getUTCDate();

		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;

		//Base Options
		this.buildingFilter.buildingClasses = [];
		this.buildingFilter.cities = [];
		this.buildingFilter.leaseTypes = [];
		this.buildingFilter.ratingToRentRatioCurrent.minimum = null;
		this.buildingFilter.ratingToRentRatioCurrent.maximum = null;
		this.buildingFilter.searchTerm = null;
		this.buildingFilter.submarkets = [];
		this.buildingFilter.districts = [];
		this.buildingFilter.postalCodes = [];

		//Building Options
		this.buildingFilter.buildingTenancies = [{ label: "Office Leased", value: "Office Leased"}];
		this.buildingFilter.buildingStatuses = [];
		this.buildingFilter.competitiveSets = [];
		this.buildingFilter.askingRent.minimum = null;
		this.buildingFilter.askingRent.maximum = null;
		this.buildingFilter.percentLeased = [0, 100];
		this.buildingFilter.directAvailableSquareFootage.minimum = null;
		this.buildingFilter.directAvailableSquareFootage.maximum = null;
		this.buildingFilter.subleaseAvailableSquareFootage.minimum = null;
		this.buildingFilter.subleaseAvailableSquareFootage.maximum = null;
		this.buildingFilter.totalVacantSquareFootage.minimum = null;
		this.buildingFilter.totalVacantSquareFootage.maximum = null;
		this.buildingFilter.directVacantSquareFootage.minimum = null;
		this.buildingFilter.directVacantSquareFootage.maximum = null;
		this.buildingFilter.subleaseVacantSquareFootage.minimum = null;
		this.buildingFilter.subleaseVacantSquareFootage.maximum = null;
		this.buildingFilter.maxContiguousSquareFootage.minimum = null;
		this.buildingFilter.maxContiguousSquareFootage.maximum = null;
		this.buildingFilter.minimumAvailableSquareFootage.minimum = null;
		this.buildingFilter.minimumAvailableSquareFootage.maximum = null;
		this.buildingFilter.occupiedSquareFootage.minimum = null;
		this.buildingFilter.occupiedSquareFootage.maximum = null;
		this.buildingFilter.availableSquareFootage = [0, this.maxValueSF];
		this.buildingFilter.subclasses = [];
		this.buildingFilter.propertyTypes = [];
		this.buildingFilter.buildingRenovations = [];
		this.buildingFilter.yearOfRenovation.minimum = null;
		this.buildingFilter.yearOfRenovation.maximum = null;
		this.buildingFilter.mixedUses = [];
		this.buildingFilter.singleTenants = [];
		this.buildingFilter.parking = [];
		this.buildingFilter.numberOfFloors.minimum = null;
		this.buildingFilter.numberOfFloors.maximum = null;
		this.buildingFilter.propertySize.minimum = null;
		this.buildingFilter.propertySize.maximum = null;
		this.buildingFilter.parkingRatio.minimum = null;
		this.buildingFilter.parkingRatio.maximum = null;
		this.buildingFilter.walkScore = [0, 100];
		this.buildingFilter.proximityToLightRail.minimum = null;
		this.buildingFilter.proximityToLightRail.maximum = null;

		this.BuildingTenancy();
		this.BuildingStatus();
		this.BuildingSquareFootageMinMaxValue();
		this.onBuildingFilterChange(event,true);
	}

	mapClicked($event: MouseEvent) {
		draggable: false
	}

	markerDragEnd(m: location, $event: MouseEvent) {
		//console.log('dragEnd', m, $event);
	}

	clickedMarker(propertyId, index: number) {
		console.log(`clicked the marker: ${index} / ${propertyId}`);

		if(!propertyId) return;

		this.buildingScoresListByPropertyId = this.buildingScoresListAll.filter(e=>e["propertyId"]==propertyId);

		for(let i = 0; i< this.buildingScoresListByPropertyId.length; i++) {
			this.buildingScoresListByPropertyId[i].oldScores = {
				constructionQuality: this.buildingScoresListByPropertyId[i].score.constructionQuality,
				askingRate: this.buildingScoresListByPropertyId[i].score.askingRate,
				commonAreaQuality: this.buildingScoresListByPropertyId[i].score.commonAreaQuality,
				onsiteAmenities: this.buildingScoresListByPropertyId[i].score.onsiteAmenities,
				sizeStories: this.buildingScoresListByPropertyId[i].score.sizeStories,
				ageBonus: this.buildingScoresListByPropertyId[i].score.ageBonus,
				locationProminence: this.buildingScoresListByPropertyId[i].score.locationProminence,
				relevanceToConsumer: this.buildingScoresListByPropertyId[i].score.relevanceToConsumer,
				locationConvenience: this.buildingScoresListByPropertyId[i].score.locationConvenience,
				locationProximity: this.buildingScoresListByPropertyId[i].score.locationProximity,
				parkingVisitorExperience: this.buildingScoresListByPropertyId[i].score.parkingVisitorExperience,
				parkingQuantity: this.buildingScoresListByPropertyId[i].score.parkingQuantity,
				parkingQuality: this.buildingScoresListByPropertyId[i].score.parkingQuality,
				totalScore: this.buildingScoresListByPropertyId[i].score.totalScore,
			}
		}

		this.toggleSnazzyInfoWindow(propertyId);

		return true;

	}

	closeMarker($event) {
		for(let i = 0; i< this.buildingScoresListByPropertyId.length; i++) {
			this.buildingScoresListByPropertyId[i].score = {
				constructionQuality: this.buildingScoresListByPropertyId[i].oldScores.constructionQuality,
				askingRate: this.buildingScoresListByPropertyId[i].oldScores.askingRate,
				commonAreaQuality: this.buildingScoresListByPropertyId[i].oldScores.commonAreaQuality,
				onsiteAmenities: this.buildingScoresListByPropertyId[i].oldScores.onsiteAmenities,
				sizeStories: this.buildingScoresListByPropertyId[i].oldScores.sizeStories,
				ageBonus: this.buildingScoresListByPropertyId[i].oldScores.ageBonus,
				locationProminence: this.buildingScoresListByPropertyId[i].oldScores.locationProminence,
				relevanceToConsumer: this.buildingScoresListByPropertyId[i].oldScores.relevanceToConsumer,
				locationConvenience: this.buildingScoresListByPropertyId[i].oldScores.locationConvenience,
				locationProximity: this.buildingScoresListByPropertyId[i].oldScores.locationProximity,
				parkingVisitorExperience: this.buildingScoresListByPropertyId[i].oldScores.parkingVisitorExperience,
				parkingQuantity: this.buildingScoresListByPropertyId[i].oldScores.parkingQuantity,
				parkingQuality: this.buildingScoresListByPropertyId[i].oldScores.parkingQuality,
				totalScore: this.buildingScoresListByPropertyId[i].oldScores.totalScore,
			}
		}

		this.closeInfoWindow($event);
	}

	mouseOver(infoWindow, $event: MouseEvent, name, iconURL) {
		// console.log("HI IM HERE");
		console.log(iconURL);
		if(document.getElementById("mapContentBox") == null){
			// infoWindow._openInfoWindow();
			infoWindow.open();
		}
	}

	mouseOut(infoWindow, $event: MouseEvent, name) {
		// console.log("HI IM HERE AGAIN");
		// infoWindow._closeInfoWindow();
		infoWindow.close();
	}

	getCurrentPreviousQuarter(value) {
		var today = new Date(),
			quarter = Math.floor((today.getMonth() / 3)),
			startDate,
			endDate;

		switch (value) {
			case "previous":
				startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
			default:
				startDate = new Date(today.getFullYear(), quarter * 3, 1);
				endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
				break;
		}

		return {
			StartDate: startDate,
			EndDate: endDate
		};
	}

	geocode(address: string): Promise<any> {
		const geocoder = new google.maps.Geocoder();
		return new Promise((resolve, reject) => {
			geocoder.geocode(
				{
					address: address
				},
				(results, status) => {
					if (status === google.maps.GeocoderStatus.OK) {
						resolve(results[0]);
					} else {
						reject(new Error(status));
					}
				}
			);
		});
	}

	BuildingScoresList() {
		//Api calling for SubMarketList
		this.scoresService.GetBuildingScoresList().subscribe(
			(res: any) => {
				this.buildingScoresList = res;
				this.markers = res;
				// console.log(res);
			},
			err => {

			}
		);
	}

	async BuildingSquareFootageMinMaxValue() {
		//Api calling for SubMarketList
		await this.scoresService.BuildingSquareFootageMinMaxValue().toPromise().then(
			(res: any) => {
				this.minValueSF = JSON.parse(res["minSFValue"]);
				this.maxValueSF = JSON.parse(res["maxSFValue"]);
				this.buildingFilter.availableSquareFootage = [0, this.maxValueSF];

			},
			err => {

			}
		);
	}

	SubMarket() {
		//Api calling for SubMarketList
		this.scoresService.SubMarketList().subscribe(
			(res: any) => {
				this.submarketOptions = res;
			},
			err => {

			}
		);
	}

	District() {
		//Api calling for districtList
		this.scoresService.DistrictList().subscribe(
			(res: any) => {
				this.districtOptions = res;
			},
			err => {

			}
		);
	}


	BuildingClass() {
		//Api calling for BuildingClassList
		this.scoresService.BuildingClassList().subscribe(
			(res: any) => {
				this.buildingClassOptions = res;
			},
			err => {

			}
		);
	}

	BuildingLeaseType() {
		//Api calling for BuildingLeaseTypeList
		this.scoresService.BuildingLeaseTypeList().subscribe(
			(res: any) => {
				this.leaseTypeOptions = res;
			},
			err => {

			}
		);
	}

	BuildingSubclass() {
		//Api calling for BuildingSubclassList
		this.scoresService.BuildingSubclassList().subscribe(
			(res: any) => {
				this.subclassOptions = res;
			},
			err => {

			}
		);
	}

	BuildingPropertyType() {
		//Api calling for BuildingPropertyTypeList
		this.scoresService.BuildingPropertyTypeList().subscribe(
			(res: any) => {
				this.propertyTypeOptions = res;
			},
			err => {

			}
		);
	}

	BuildingRenovations() {
		//Api calling for BuildingRenovationsList
		this.scoresService.BuildingRenovationsList().subscribe(
			(res: any) => {
				this.buildingRenovationOptions = res;
			},
			err => {

			}
		);
	}

	BuildingMixedUse() {
		//Api calling for BuildingMixedUseList
		this.scoresService.BuildingMixedUseList().subscribe(
			(res: any) => {
				this.mixedUseOptions = res;
			},
			err => {

			}
		);
	}

	BuildingSingleTenant() {
		//Api calling for BuildingSingleTenantList
		this.scoresService.BuildingSingleTenantList().subscribe(
			(res: any) => {
				this.singleTenantOptions = res;
			},
			err => {

			}
		);
	}

	BuildingParking() {
		//Api calling for BuildingParkingList
		this.scoresService.BuildingParkingList().subscribe(
			(res: any) => {
				this.parkingOptions = res;
			},
			err => {

			}
		);
	}

	BuildingStatus() {
		//Api calling for BuildingStatusList
		this.scoresService.BuildingStatusList().subscribe(
			(res: any) => {
				this.buildingStatusOptions = res;
			},
			err => {

			}
		);
	}

	BuildingTenancy() {
		//Api calling for BuildingTenancyList
		this.scoresService.BuildingTenancyList().subscribe(
			(res: any) => {
				this.buildingTenantOptions = res;
			},
			err => {

			}
		);
	}

	CompetitiveSet() {
		//Api calling for competitiveSetOptions
		this.scoresService.CompetitiveSetList(sessionStorage.getItem('id')).subscribe(
			(res: any) => {
				this.competitiveSetOptions = res;
			},
			err => {

			}
		);
	}

	CanEditScores() {
		return this.GetRole() == 'admin';
	}

	GetRole() {
		return window.sessionStorage.role;
	}

	submitBuildingScores($event, detail) {
		this.scoresService.UpdateBuildingScores(detail.score, this.buildingFilter.scoreWeightId).subscribe(
			(res:any)=> {
				const item = this.buildingScoresListByPropertyId.find(item => item.propertyId === detail.propertyId);
  
				if (item) {
					item.score = res;
				}

				this.closeInfoWindow($event);
			},
			err=> {
				console.error(err);
			})
	}

	clearURLParams($event) {
		if(!this.route.url.includes('buildingScores'))
			return;
		console.log(`Clearing URL Params: `,$event);
		// console.log(this.route.parseUrl(this.route.url));
		console.log(this.route.url);
		this.route.navigate([],{
			queryParams: {
				'propertyId':null,
			},
			queryParamsHandling:'merge'
		})
	}

	closeInfoWindow($event) {
		$('.si-close-button').click();
		this.isSnazzyInfoWindowOpened = {};
		this.route.navigate([],{
			queryParams: {
				'propertyId':null,
			},
			queryParamsHandling:'merge'
		})
	}

	getScoreWeightByName(name) {
		// console.log(`incoming name: ${name}`);
		return this.scoreWeight[name];
	}

	calculateTotalBuildingScore($event,detail) {
		let totalScore = 0;
		totalScore += this.calculateWeightedScore( detail.score.constructionQuality, this.scoreWeight.constructionQuality );
		totalScore += this.calculateWeightedScore( detail.score.askingRate, this.scoreWeight.askingRate );
		totalScore += this.calculateWeightedScore( detail.score.commonAreaQuality, this.scoreWeight.commonAreaQuality );
		totalScore += this.calculateWeightedScore( detail.score.onsiteAmenities, this.scoreWeight.onsiteAmenities );
		totalScore += this.calculateWeightedScore( detail.score.sizeStories, this.scoreWeight.sizeStories );
		totalScore += this.calculateWeightedScore( detail.score.ageBonus, this.scoreWeight.ageBonus );
		totalScore += this.calculateWeightedScore( detail.score.locationProminence, this.scoreWeight.locationProminence );
		totalScore += this.calculateWeightedScore( detail.score.relevanceToConsumer, this.scoreWeight.relevanceToConsumer );
		totalScore += this.calculateWeightedScore( detail.score.locationConvenience, this.scoreWeight.locationConvenience );
		totalScore += this.calculateWeightedScore( detail.score.locationProximity, this.scoreWeight.locationProximity );
		totalScore += this.calculateWeightedScore( detail.score.parkingVisitorExperience, this.scoreWeight.parkingVisitorExperience );
		totalScore += this.calculateWeightedScore( detail.score.parkingQuantity, this.scoreWeight.parkingQuantity );
		totalScore += this.calculateWeightedScore( detail.score.parkingQuality, this.scoreWeight.parkingQuality );

		//mult by 10 because that's what they want
		totalScore = totalScore * 10;

		detail.score.totalScore = totalScore;

		return true;
	}

	calculateWeightedScore(score: number, weight: number) {
		if (score == null) {
			return 0;
		}

		score = Math.min(10,Math.max(0,score))

		if (weight != 0) {
			return (.01*weight*score)
		}

		return 0;
	}

	caluculateTotleSQFT() {
		let listchange1: any[];
		listchange1 = this.buildingScoresList;
		for (let i: number = 0; i < this.buildingScoresList.length; i++) {

			if (i <= 13) {
				this.totalSQFt += this.buildingScoresList[i].buildingNRA;
				this.totalVancentSQFt += this.buildingScoresList[i].dVacantSF;
			}
		}
		this.percentvacant = (Number(this.totalVancentSQFt) / Number(this.totalSQFt)) * 100;
	}

	onDateChanged(event, dateType) {

		if (dateType == 'from') {

			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0)
			{
				this.fromDate = null;
				this.FromDateString = "";
			}
			else {
				let fromdate = event.formatted;
				this.FromDateString = fromdate;//this.datePipe.transform(new Date(event.date.year, event.date.month - 1, event.date.day ), 'MM/dd/yyyy');//"YEAR#" + event.date.year + "@@MONTH#" + (event.date.month ) + "@@DAY#" + (event.date.day);
				this.fromDate = new Date(event.date.year, event.date.month - 1, event.date.day + 1);

			}
		}
		else {
			if (event.date.year == 0 && event.date.month == 0 && event.date.day == 0) {
				this.endDate = null;
				this.ToDateString = "";
			}
			else {
				let todate = event.formatted;
				this.endDate = new Date(event.date.year, event.date.month - 1, event.date.day + 1);
				this.ToDateString = todate;//this.datePipe.transform(this.endDate, 'MM/dd/yyyy');//"YEAR#" + event.date.year + "@@MONTH#" + (event.date.month) + "@@DAY#" + (event.date.day);


			}
		}
		// this.FromDateString = "YEAR#" + event.date.year + "@@MONTH#" + (event.date.month- 1) + "@@DAY#" + event.date.day + 1;
		// this.ToDateString = "YEAR#" + this.endDate.getFullYear() + "@@MONTH#" + this.endDate.getMonth() + 1 + "@@DAY#" + this.endDate.getDate();

		this.marketService.myFromDate = this.FromDateString;
		this.marketService.myToDate = this.ToDateString;
	}

	async onBuildingFilterChange(eventData, IsRefreshMap = false) {
		if (!IsRefreshMap) {
			return;
		}
		
		if  (this.FilterType !== '')  {
			(<HTMLSelectElement>document.getElementById('sort')).value = this.FilterType;
			(<HTMLSelectElement>document.getElementById('sort-order')).value = 'descending';
		}
		
		if (eventData != null) {
			this.setDateOnSelectPicker = true;
		}
		
		this.MapLoader = true;
		this.propertyId = '';

		//Stored data into sevice property to use further implemenation
		this.marketService.inputFilterSearchTerm = this.buildingFilter.searchTerm;
		this.marketService.subMarket = this.buildingFilter.submarkets.map(function(x){return x.value;}).join(",");
		this.marketService.district = this.buildingFilter.districts.map(function(x){return x.value;}).join(",");
		this.marketService.class = this.buildingFilter.buildingClasses.map(function(x){return x.value;}).join(",");
		this.marketService.tenancy = this.buildingFilter.buildingTenancies.map(function(x){return x.value;}).join(",");
		this.marketService.status = this.buildingFilter.buildingStatuses.map(function(x){return x.value;}).join(",");
		this.marketService.leaseType = this.buildingFilter.leaseTypes.map(function(x){return x.value;}).join(",");

		this.marketService.rangeSFValuesMin = this.buildingFilter.availableSquareFootage[0];
		this.marketService.rangeSFValuesMax = this.buildingFilter.availableSquareFootage[1];

		this.marketService.rangePercentLeasedValuesMin = this.buildingFilter.percentLeased[0];
		this.marketService.rangePercentLeasedValuesMax = this.buildingFilter.percentLeased[1];

		this.marketService.rangeNumberOfFloorMinValues = this.buildingFilter.numberOfFloors.minimum;
		this.marketService.rangeNumberOfFloorMaxValues = this.buildingFilter.numberOfFloors.maximum;

		this.marketService.rangePropertySizeMin = this.buildingFilter.propertySize.minimum;
		this.marketService.rangePropertySizeMax = this.buildingFilter.propertySize.maximum;

		this.marketService.inputparkingRatioMinValue = this.buildingFilter.parkingRatio.minimum;
		this.marketService.inputparkingRatioMaxValue = this.buildingFilter.parkingRatio.maximum;

		this.marketService.rangeWalkScoreValuesMin = this.buildingFilter.walkScore[0];
		this.marketService.rangeWalkScoreValuesMax = this.buildingFilter.walkScore[1];

		this.marketService.inputMinValueAskingRent = this.buildingFilter.askingRent.minimum;
		this.marketService.inputMaxValueAskingRent = this.buildingFilter.askingRent.maximum;

		this.marketService.inputLightRailMinValue = this.buildingFilter.proximityToLightRail.minimum;
		this.marketService.inputLightRailMaxValue = this.buildingFilter.proximityToLightRail.maximum;

		this.marketService.inputavailableSFDirectMinValue = this.buildingFilter.directAvailableSquareFootage.minimum;
		this.marketService.inputavailableSFDirectMaxValue = this.buildingFilter.directAvailableSquareFootage.maximum;

		this.marketService.inputavailableSFSLMinValue = this.buildingFilter.subleaseAvailableSquareFootage.minimum;
		this.marketService.inputavailableSFSLMaxValue = this.buildingFilter.subleaseAvailableSquareFootage.maximum;

		this.marketService.inputttlVacantSFMinValue = this.buildingFilter.totalVacantSquareFootage.minimum;
		this.marketService.inputttlVacantSFMaxValue = this.buildingFilter.totalVacantSquareFootage.maximum;

		this.marketService.inputdVacantSFMinValue = this.buildingFilter.directVacantSquareFootage.minimum;
		this.marketService.inputdVacantSFMaxValue = this.buildingFilter.directVacantSquareFootage.maximum;

		this.marketService.inputslVacantSFMinValue = this.buildingFilter.subleaseVacantSquareFootage.minimum;
		this.marketService.inputslVacantSFMaxValue = this.buildingFilter.subleaseVacantSquareFootage.maximum;

		this.marketService.inputcontiguousSFMinValue = this.buildingFilter.maxContiguousSquareFootage.minimum;
		this.marketService.inputcontiguousSFMaxValue = this.buildingFilter.maxContiguousSquareFootage.maximum;

		this.marketService.inputminAvailableSFMinValue = this.buildingFilter.minimumAvailableSquareFootage.minimum;
		this.marketService.inputminAvailableSFMaxValue = this.buildingFilter.minimumAvailableSquareFootage.maximum;

		this.marketService.inputoccupiedSFMinValue = this.buildingFilter.occupiedSquareFootage.minimum;
		this.marketService.inputoccupiedSFMaxValue = this.buildingFilter.occupiedSquareFootage.maximum;

		this.marketService.inputRatingToRentRatioMinValue = this.buildingFilter.ratingToRentRatioCurrent.minimum;
		this.marketService.inputRatingToRentRatioMaxValue = this.buildingFilter.ratingToRentRatioCurrent.maximum;

		this.marketService.subclass = this.buildingFilter.subclasses.map(function(x){return x.value;}).join(",");

		this.marketService.propertyType = this.buildingFilter.propertyTypes.map(function(x){return x.value;}).join(",");
		
		this.marketService.renovations = this.buildingFilter.buildingRenovations.map(function(x){return x.value;}).join(",");

		this.marketService.inputyearOfRenovationMinValue = this.buildingFilter.yearOfRenovation.minimum;
		this.marketService.inputyearOfRenovationMaxValue = this.buildingFilter.yearOfRenovation.maximum;

		this.marketService.mixedUse = this.buildingFilter.mixedUses.map(function(x){return x.value;}).join(",");

		this.marketService.singleTenant = this.buildingFilter.singleTenants.map(function(x){return x.value;}).join(",");

		this.marketService.parking = this.buildingFilter.parking.map(function(x){return x.value;}).join(",");

		this.marketService.competitiveSet = this.buildingFilter.competitiveSets.map(function(x){return x.value;}).join(",");
	
		this.scoresService.competitiveSet = this.buildingFilter.competitiveSets.map(function(x) { return x.value; }).join(",");
		this.deletedPropertyIdFromOfficeBuildingList = "";
		this.scoresService.deletedPropertyIdFromOfficeBuildingListService = "";
	
		this.marketService.MarkersDetailbyFilter().subscribe(async (res: any) => {

			this.listRatingFiltersComponent.filterBuildings(res).subscribe(async filteredBuildings => {

				this.buildingScoresListAll = filteredBuildings;

				await this.buildingSort(false);

				this.scoresService.buildingScoresList = filteredBuildings;

				this.pushInMarker();

				if(this.myMap) {
					console.log('Setting Timeout to resize map bounds ...');
					setTimeout(()=>{
						const bounds: LatLngBounds = new google.maps.LatLngBounds();
						let boundsCheck = [];
						if(this.markers && this.markers.length > 0/*100*/) {
							//	make it a little easier on the poor bounds checker...
							let maxLat = this.markers[0], minLat = this.markers[0], maxLong = this.markers[0], minLong = this.markers[0];
							for(const mm of this.markers) {
								if(mm.latitude < minLat.latitude) {
									minLat = mm;
								}
								if(mm.latitude > maxLat.latitude) {
									maxLat = mm;
								}
								if(mm.longitude < minLong.longitude) {
									minLong = mm;
								}
								if(mm.longitude > maxLong.longitude) {
									maxLong = mm;
								}
							}
							boundsCheck = [maxLat,minLat,maxLong,minLong];

						}
						else {
							boundsCheck = this.markers;
						}
						for (const mm of boundsCheck) {
							bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
							// console.log(bounds.toString());
						}
						this.myMap.fitBounds(bounds);
						setTimeout(()=>{
							let query = this.route.parseUrl(this.route.url).queryParams;
							setTimeout(()=>this.clickedMarker(query.propertyId,0),0);
							// console.log('zooming out...?');
							this.zoom--;

							// if(query.propertyId) {

						},1000);

						// console.log('Bounds resized.');
					},1000);
				}
			});
		},
		err => {
			this.MapLoader = false;
		});
	}
	CLMarkers() {
		console.log(this.markers);
	}

	async buildingSort(event) {

		if(!(<HTMLSelectElement>document.getElementById('sort'))) {
			setTimeout(async ()=>await this.buildingSort(event),100);
			return;
		}
		
		this.sortParam = (<HTMLSelectElement>document.getElementById('sort')).value;
		this.sortOrder = (<HTMLSelectElement>document.getElementById('sort-order')).value;
		this.sortBtn = (<HTMLSelectElement>document.getElementById('btn-sort'));

		this.sortBtn.textContent = "...";
		this.sortBtn.disabled = true;
		console.log('pre 1st delay!');
		await ((delay) => {
    		return new Promise((resolve)=> setTimeout(resolve, delay)); // Note the order, `delay` before `value`
	        /* Or for outdated browsers that don't support doing that:
	        setTimeout(function() {
	            resolve(value);
	        }, delay);
	        Or alternately:
	        setTimeout(resolve.bind(null, value), delay);
	        */
		} ) (0);
		console.log('post 1st delay!');

		// this.onBuildingFilterChange(event, true);
		if(this.sortOrder == 'ascending'){
			this.buildingScoresListAll.sort((a, b)=> {	//	NOTE THAT THIS IS (a, b) -- WHICH IS DIFFERENT THAN THE 'descending' BLOCK BELOW

				let sorted = Number(a.score[this.sortParam]) - Number(b.score[this.sortParam]);	//first sort by the score selected
				if(!sorted) {
					sorted = Number(a.score.totalScore) - Number(b.score.totalScore);	//	if it's a tie, sort by total score
				}
				if(!sorted) {	// if it's STILL a tie, sort by name
					const bA = (a.buildingName).toLowerCase().replace(/[^a-z0-9]/gm, '')
					const bB = (b.buildingName).toLowerCase().replace(/[^a-z0-9]/gm, '')
					sorted = bA.localeCompare(bB);
				}
				return sorted;
			});

		}
		else if(this.sortOrder == 'descending') {
			this.buildingScoresListAll.sort((b, a)=> {	//	NOTE THAT THIS IS (b, a) -- WHICH IS DIFFERENT THAN THE 'ascending' BLOCK ABOVE

				let sorted = Number(a.score[this.sortParam]) - Number(b.score[this.sortParam]);	//first sort by the score selected
				if(!sorted) {
					sorted = Number(a.score.totalScore) - Number(b.score.totalScore);	//	if it's a tie, sort by total score
				}
				if(!sorted) {	// if it's STILL a tie, sort by name
					const bA = (a.buildingName).toLowerCase().replace(/[^a-z0-9]/gm, '')
					const bB = (b.buildingName).toLowerCase().replace(/[^a-z0-9]/gm, '')
					sorted = bA.localeCompare(bB);
				}
				return sorted;
			});
		}
		
		if (this.FilterType !== '') {
			let min = 1;
			let max = this.buildingScoresListAll.length;

			switch (this.FilterType) {
				case "TotalScore":					
					({ min, max } = formatMinMax(this.buildingFilter.total.numeric, this.buildingFilter.total.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "ConstructionQuality":
					({ min, max } = formatMinMax(this.buildingFilter.constructionQuality.numeric, this.buildingFilter.constructionQuality.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "AskingRate":						
					({ min, max } = formatMinMax(this.buildingFilter.askingRate.numeric, this.buildingFilter.askingRate.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "CommonAreaQuality":
					({ min, max } = formatMinMax(this.buildingFilter.commonAreaQuality.numeric, this.buildingFilter.commonAreaQuality.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "OnsiteAmenities":
					({ min, max } = formatMinMax(this.buildingFilter.onSiteAmenities.numeric, this.buildingFilter.onSiteAmenities.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "SizeStories":
					({ min, max } = formatMinMax(this.buildingFilter.sizeStories.numeric, this.buildingFilter.sizeStories.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "AgeBonus":
					({ min, max } = formatMinMax(this.buildingFilter.ageBonus.numeric, this.buildingFilter.ageBonus.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "LocationProminence":
					({ min, max } = formatMinMax(this.buildingFilter.locationProminence.numeric, this.buildingFilter.locationProminence.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "RelevanceToConsumer":
					({ min, max } = formatMinMax(this.buildingFilter.relevanceToConsumer.numeric, this.buildingFilter.relevanceToConsumer.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "LocationConvenience":
					({ min, max } = formatMinMax(this.buildingFilter.locationConvenience.numeric, this.buildingFilter.locationConvenience.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "LocationProximity":
					({ min, max } = formatMinMax(this.buildingFilter.locationProximity.numeric, this.buildingFilter.locationProximity.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "ParkingVisitorExperience":
					({ min, max } = formatMinMax(this.buildingFilter.parkingVisitorExperience.numeric, this.buildingFilter.parkingVisitorExperience.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "ParkingQuantity":
					({ min, max } = formatMinMax(this.buildingFilter.parkingQuantity.numeric, this.buildingFilter.parkingQuantity.percentage, min, max, this.buildingScoresListAll.length));
					break;
				case "ParkingQuality":
					({ min, max } = formatMinMax(this.buildingFilter.parkingQuality.numeric, this.buildingFilter.parkingQuality.percentage, min, max, this.buildingScoresListAll.length));
					break;
				default:
					break;
			}			

			if(min !== 1 || max !== this.buildingScoresListAll.length){
				this.buildingScoresListAll = this.buildingScoresListAll.filter((_element, index, _array) => {
					const adjustedIndex = index + 1;
					return adjustedIndex >= min && adjustedIndex <= max;
				});
			}
		}

		this.buildingScoresList = this.buildingScoresListAll.slice(0,this.DEBUG_LIMIT_RESULTS||undefined);

		this.buildingScoresListCopy = this.buildingScoresList.slice(0,50);
		this.scoresService.buildingScoresList = this.buildingScoresListCopy;
		this.markers = this.buildingScoresList.slice(0);
		this.sortBtn.textContent = "SORT";
		this.sortBtn.disabled = false;
		console.log('pre 2nd-delay!');
		await ((delay) => {
    		return new Promise((resolve)=> setTimeout(resolve, delay)); // Note the order, `delay` before `value`
	        /* Or for outdated browsers that don't support doing that:
	        setTimeout(function() {
	            resolve(value);
	        }, delay);
	        Or alternately:
	        setTimeout(resolve.bind(null, value), delay);
	        */
		} ) (0);
		console.log('post 2nd delay!');

		function formatMinMax(numberRange: string[], percentRange: string[], min: number, max: number, total: number) {
			if (numberRange[0] !== defaultMaxValue || numberRange[1] !== defaultMinValue) {
				min = formatNumberRange(numberRange[0], min);
				max = formatNumberRange(numberRange[1], max);
			}
			else if (percentRange[0] !== defaultMaxValue || percentRange[1] !== defaultMinValue) {
				min = formatPercentRange(percentRange[0], min, total);
				max = formatPercentRange(percentRange[1], max, total);
			}

			return { min, max };

			function formatNumberRange (value: string, defaultValue: number): number {
				const parsedValue = parseFloat(value);
				return !isNaN(parsedValue) ? parsedValue : defaultValue;
			}

			function formatPercentRange (value: string, defaultValue: number, total: number): number {
				const parsedValue = parseFloat(value);
				if(!isNaN(parsedValue)) {
					return parsedValue * .01 * total;
				} else {
					return defaultValue;
				}
			}
		}
	}

	//Event click on box on right side of map 07102019
	pushInMarkerSingle(obj): void {

		if (this.isPageFirstTime == true) {
			this.isMarkerSingle = true;
			this.Buildingobj = Object.create(obj);
			this.totalbuilding = 1;
			this.markers = [obj.location];
			let Rsf = 0;
			let Sf = 0;
			this.buildingScoresListCopy = [obj];
			// console.log("Single click" + this.buildingScoresListCopy);
			this.pushInMarker();
			//this.absorptionForOccupiedSF = obj["occupiedSF"];
			this.propertyId = obj["propertyId"]
			// this.CalculateAbsorptionForOccupiedSF(event);
			this.buildingScoresListCopy.filter(function (location) {
				Rsf = Number(Rsf) + Number(location["buildingNRA"]);
				Sf = Number(Sf) + Number(location["ttlVacantSF"]);
			});
			// this.markers = locationArray;
			this.Buildingobj.Rsf = Rsf;
			this.Buildingobj.Sf = Sf;
			this.rightSectionColor = { 'background': '#b9c7d0' };
			this.totalPercentage = (Number(obj["ttlVacantSF"]) / Number(obj["buildingNRA"])) * 100;
			this.isPageFirstTime = false;
			this.isMarkerSingle = false;
			this.scoresService.propertyId = obj["propertyId"];
			this.scoresService.buildingScoresList = this.buildingScoresListCopy;
		}
		else {
			this.propertyId = '';
			this.scoresService.propertyId = "";
			this.onBuildingFilterChange(event,true);
			this.rightSectionColor = { 'background': '#ffffff' };
			this.isPageFirstTime = true;
		}
	};

	//Calculate value for building 05102019
	pushInMarker() {
		//pointer coloring base on building 11102019
		let listchange: any[];
		if (this.isMarkerSingle) {
			listchange = this.buildingScoresListCopy;
		}
		else {
			listchange = this.buildingScoresList;
		}
		this.deletedIdOfficeBuilding.length = 0;
		this.buildingScoresList = listchange;
		// listchange.forEach((Buildingobj, index) => {

		// 	Buildingobj["iconUrl"] = this.IconUrl + Buildingobj.submarketCode;
		// });

		for(var lc of listchange) {
			lc['iconUrl'] = this.IconUrl + lc['submarketCode'];
		}

		this.caluculateTotleSQFT()
		var that = this;
		let Rsf = 0;
		let Sf = 0;
		listchange.filter(function (location) {
			Rsf = Number(Rsf) + Number(location["buildingNRA"]);
			Sf = Number(Sf) + Number(location["ttlVacantSF"]);
		});
		// this.markers = locationArray;
		this.Buildingobj.Rsf = Rsf;
		this.Buildingobj.Sf = Sf;
		this.totalPercentage = (Number(that.Buildingobj.Sf) / Number(that.Buildingobj.Rsf)) * 100;
		that.totalbuilding = listchange.length;
		this.MapLoader = false;
		//this.loader = false;

		this.scoresService.CalculateStats(listchange, this.scoreWeight.id);
	};

	//Remove building from right side map 05102019
	DeleteFromArray(index, id, propertyId1) {
		sessionStorage.setItem('PrevisousAbsorption', this.absorptionForOccupiedSF);
		this.propertyId = propertyId1;
		// this.CalculateAbsorptionForOccupiedSF(event);
		//Maintaining deleted property id
		this.deletedPropertyIdFromOfficeBuildingList += propertyId1 + ",";
		this.buildingScoresList.splice(index, 1);
		this.buildingScoresListCopy.splice(index, 1);
		this.scoresService.buildingScoresList = this.buildingScoresListCopy;
		let customObj = new Custom();
		customObj.id = id;
		this.deletedIdOfficeBuilding.push(customObj);
		this.deletedIdOfficeBuilding.length;
		var that = this;
		let Rsf = 0;
		let Sf = 0;

		if (this.buildingScoresListCopy.length == 0) {
			this.buildingScoresListCopy.filter(function (location) {
				Rsf = 0;
				Sf = 0;

			});
			this.absorptionForOccupiedSF = '0';
		}
		that.buildingScoresList.filter(function (location) {
			Rsf = Number(Rsf) + Number(location["buildingNRA"]);
			Sf = Number(Sf) + Number(location["ttlVacantSF"]);
		});

		this.Buildingobj.Rsf = Rsf;
		this.Buildingobj.Sf = Sf;
		this.totalPercentage = (Number(that.Buildingobj.Sf / Number(that.Buildingobj.Rsf))) * 100;
		that.totalbuilding = that.buildingScoresList.length;
		//Stroring deleted property id into services
		this.scoresService.deletedPropertyIdFromOfficeBuildingListService = this.deletedPropertyIdFromOfficeBuildingList;

		this.scoresService.CalculateStats(this.buildingScoresList, this.scoreWeight.id);
	}

	CalculateAbsorptionForOccupiedSF(event) {
		this.MapLoader = true;

		//if (this.inputMinValueAskingRent.nativeElement.value <= this.inputMaxValueAskingRent.nativeElement.value) { }
		//else { alert("Please enter a valid min and max value for ASKING RENT"); }
		//Api calling for SubMarketList  str.substring(0, str.length - 1)
		this.scoresService.CalculateAbsorptionForOccupiedSF(
			this.propertyId,
			this.fromDate,
			this.endDate,
			this.buildingFilter.submarkets.map(function(x){return x.value;}).join(","),
			this.buildingFilter.districts.map(function(x){return x.value;}).join(","),
			this.buildingFilter.buildingClasses.map(function(x){return x.value;}).join(","),
			this.buildingFilter.buildingTenancies.map(function(x){return x.value;}).join(","),
			this.buildingFilter.buildingStatuses.map(function(x){return x.value;}).join(","),
			this.buildingFilter.leaseTypes.map(function(x){return x.value;}).join(","),
			this.buildingFilter.maxContiguousSquareFootage.minimum,
			this.buildingFilter.maxContiguousSquareFootage.maximum,
			this.buildingFilter.availableSquareFootage[0], 
			this.buildingFilter.availableSquareFootage[1],
			this.buildingFilter.numberOfFloors.minimum,
			this.buildingFilter.numberOfFloors.maximum,
			this.buildingFilter.propertySize.minimum,
			this.buildingFilter.propertySize.maximum,
			this.buildingFilter.parkingRatio.minimum,
			this.buildingFilter.parkingRatio.maximum,
			this.buildingFilter.walkScore[0],
			this.buildingFilter.walkScore[1],
			this.buildingFilter.askingRent.minimum,
			this.buildingFilter.askingRent.maximum,
			this.selectedFromQuarterstr1,
			this.selectedFromQuarterstr2,
			this.buildingFilter.competitiveSets.map(function(x){return x.value;}).join(",")
		).subscribe(
				(res: any) => {
					if (res == null) {
						this.absorptionForOccupiedSF = '0';
						this.MapLoader = false;
					}
					else {
						this.absorptionForOccupiedSF = res;
						this.MapLoader = false;
						this.PreviousAbsoptionData = sessionStorage.getItem('PrevisousAbsorption');
						if (this.PreviousAbsoptionData != null) {
							this.CurrentabsorptionData = parseInt(this.PreviousAbsoptionData) - parseInt(this.absorptionForOccupiedSF);
							this.absorptionForOccupiedSF = this.CurrentabsorptionData.toString();
							sessionStorage.removeItem('PrevisousAbsorption');
							this.propertyId = '';
							this.MapLoader = false;
						}
					}
				},
				err => {
					this.MapLoader = false;
				}
			);
	}

	toggleInfoboxInput($event) {
		// console.log($event);

		if(!this.CanEditScores()) {
			return;
		}

		let elt = $event.srcElement;
		$(elt).hide();

		let inputDiv = $(elt).prev();
		inputDiv.show();
		let input = inputDiv.find('input')[0];
		// input.setSelectionRange(0,input.value.length);
		input.focus();
		input.select();
	}

	toggleInputInfobox($event) {
		// console.log(`toggleInputInfobox`);
		// console.log($event);
		let elt = $event.srcElement;
		if(!$(elt).hasClass('ng-dirty')) {
			$(elt).parent().hide();
			let infoboxDiv = $(elt).parent().next();
			infoboxDiv.show();
		}

		// let input = inputDiv.find('input')[0];
		// input.setSelectionRange(0,input.value.length);
		// input.focus();
		// input.select();
	}

	ShowAllBuildingRecord() {
		this.MapLoader = true;
		this.buildingScoresListCopy = this.buildingScoresListAll;
		this.scoresService.buildingScoresList = this.buildingScoresListCopy;
		this.MapLoader = false;
	}
	ReloadResultSetData() {
		this.onBuildingFilterChange(event,true);
	}

	GetMapTypeId(mapType) {
		this.scoresService.mapTypeIdSelected = mapType;
		//alert(event);
	}
}

// Interface for the Map
interface marker {

	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
	iconUrl: string;
}

interface Absorption {
	id: string,
	quarterYear: string

}

export interface location {
	latitude: number;
	longitude: number;
	label?: string;
	draggable: boolean;
}
export class MyModel {

	val: number = 100;
	rangeValues: number[] = [20, 80];
}
export class Custom {
	id: number
}